import api from "../../../shared/services/api";

export async function getPerfil(contaId) {
  const response = await api.get(`/whatsapp/meta/contas/${contaId}/perfil`);
  return response.data?.perfil || {};
}

export async function updatePerfil(contaId, fields) {
  const response = await api.patch(`/whatsapp/meta/contas/${contaId}/perfil`, fields);
  return response.data?.perfil;
}

export async function uploadFoto(contaId, file) {
  const formData = new FormData();
  formData.append("foto", file);
  const response = await api.post(`/whatsapp/meta/contas/${contaId}/perfil/foto`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data?.perfil;
}
